import styled from 'styled-components';
import { Button } from '../Button';
import { Ellipsis } from '../Ellipsis';
import { Stack, StackItem } from '../Layout';
import { getInterFontWeightCSS, theme } from '../theme';
import { tokens } from './tokens';
export const StyledAlert = styled(Stack)`
  font-family: ${tokens.Alert.fontFamily};
  gap: ${tokens.Alert.gap};
  padding: ${tokens.Alert.padding};
  border-radius: ${tokens.Alert.borderRadius};
  background-color: ${tokens.Alert.backgroundColor};
  border: 1px solid ${tokens.Alert.borderColor};
  box-shadow: ${tokens.Alert.boxShadow};
  color: ${tokens.Alert.color};
  pointer-events: all;

  ${(props)=>props.$banner && `
      border-radius: 0;
      border-width: 0;
      border-bottom: 1px solid ${theme.colors.gray300};
      width: 100%;
    `}
`;
export const StyledText = styled(Stack)`
  font-size: ${tokens.Alert.Content.fontSize};
  line-height: ${tokens.Alert.Content.lineHeight};
  ${getInterFontWeightCSS(tokens.Alert.Content.text.fontWeight)};
  color: ${tokens.Alert.Content.text.color};
  white-space: nowrap;
`;
export const StyledSupportingText = styled(Ellipsis)`
  font-size: ${tokens.Alert.Content.fontSize};
  line-height: ${tokens.Alert.Content.lineHeight};
  ${getInterFontWeightCSS(tokens.Alert.Content.supportingText.fontWeight)};
  color: ${tokens.Alert.Content.supportingText.color};
`;
export const StyledContent = styled(StackItem)`
  display: flex;
  flex-direction: column;
  gap: ${theme.sizes.x4};

  ${(props)=>props.$banner && `
      flex-direction: row;
      gap: ${theme.spaces.x6};
    `}
`;
export const StyledContentWrapper = styled(StackItem)`
  display: flex;
  ${(props)=>!props.$banner && `justify-content: center;`}
  flex-direction: column;
  gap: ${theme.sizes.x12};

  ${(props)=>props.$banner && `
      flex-direction: row;
      align-items: center;

    `}
`;
export const StyledActionButtonsWrapper = styled(Stack)`
  display: flex;
  gap: ${theme.sizes.x12};
`;
export const StyledCloseButton = styled(Button)`
  align-self: flex-start;

  ${(props)=>(props.$banner || props.$isSingleLine) && `
      align-self: center;
    `}
`;
